import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

const CurrentUserProfile = gql`
query CurrentUser($email: String!) {
  User(email: $email) {
    id,
    email,
    name,
  }
}`;

const addUser = gql`
mutation addUser($name: String!, $email: String!, $idToken: String!) {
  createUser(name: $name, email: $email, authProvider: {auth0: {idToken: $idToken}}) {
    id,
    name,
    email
  }
}`;

@Injectable()
export class UserService {

  constructor(private apollo: Apollo) { }

  addNewUser(name: string, email: string, idToken: string) {
    return this.apollo.mutate({
      mutation: addUser,
      variables: {
        name: name,
        email: email,
        idToken: idToken
      }
    });
  }

  getCurrentUser(email: string) {
    return this.apollo.watchQuery({
      query: CurrentUserProfile,
      variables: {
        email: email
      }
    });
  }
}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/services/user.service.ts